import {
  BadgeCheck,
  Fingerprint,
  MessageSquare,
  Quote,
  Sparkles,
  TrendingUp,
  type LucideIcon,
} from "lucide-react";

/** Icon names used in `ai-visibility-geo-subpage.json`. */
const ICONS: Record<string, LucideIcon> = {
  BadgeCheck,
  Fingerprint,
  MessageSquare,
  Quote,
  Sparkles,
  TrendingUp,
};

export function geoIcon(name: string): LucideIcon {
  return ICONS[name] ?? Sparkles;
}
